// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import NfcScannerController from "./nfc_scanner_controller"
application.register("nfc-scanner", NfcScannerController)

import RefreshController from "./refresh_controller"
application.register("refresh", RefreshController)

import LolController from "./lol_controller"
application.register("lol", LolController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)

import QrScannerBetaController from "./qr_scanner_beta_controller"
application.register("qr-scanner-beta", QrScannerBetaController)

import HolographicCardController from "./holographic_card_controller"
application.register("holographic-card", HolographicCardController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ChecklistController from "./checklist_controller"
application.register("checklist", ChecklistController)

import PassportMapController from "./passport_map_controller"
application.register("passport-map", PassportMapController)

import PassportFlightsController from "./passport_flights_controller"
application.register("passport-flights", PassportFlightsController)

import PassportFlowsController from "./passport_flows_controller"
application.register("passport-flows", PassportFlowsController)

import PassportRoutesController from "./passport_routes_controller"
application.register("passport-routes", PassportRoutesController)

import PassportRaceController from "./passport_race_controller"
application.register("passport-race", PassportRaceController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)
